import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { useTRPC } from "@/lib/trpc";

export const useSuspenseMembers = () => {
    const trpc = useTRPC();
    const opts = trpc.user.members.queryOptions();
    const { data } = useSuspenseQuery(opts);
    return data;
};

export const useMembers = (options?: { staleTime?: number; gcTime?: number }) => {
    const trpc = useTRPC();
    const opts = trpc.user.members.queryOptions(undefined, options);
    return useQuery(opts);
};

export const useInvitations = () => {
    const trpc = useTRPC();
    const opts = trpc.user.invitations.queryOptions();
    return useQuery(opts);
};

export const useMemberships = () => {
    const trpc = useTRPC();
    const opts = trpc.user.memberships.queryOptions();
    return useQuery(opts);
};
